module.exports = __webpack_public_path__ + "img/hr-green-hairy-grass-05.52f71099.png";